<div style="margin: 100px auto;
text-align: center;">
    <img src="../../../assets/img/common icons/logoutimg.jpg" style="width: 600px;
    display: block;
    margin: auto;" />
    <p><b>You have been  successfully logged out from the SSO portal</b></p>
    <button class="btn btn-primary" (click)="goto()">Home</button>
</div>
